import React, {useMemo, useRef, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryGetPoint from '../../hooks/api/point/useQueryGetPoint'
import TableHeader from '../../components/table/TableHeader'
import Text from '../../components/text/Text'
import TableLayout from '../../components/table/TableLayout'
import TableItem from '../../components/table/TableItem'
import WizPagination from '../../components/pagination/WizPagination'
import WizButton from '../../components/button/WizButton'
import useQueryGetPointSummary from '../../hooks/api/point/useQueryGetPointSummary'
import Span from '../../components/text/Span'
import {useDisplayNumber} from '../../utils/number'
import useNavigation from '../../hooks/useNavigation'
import PointDueToReferralModal from '../../features/page/point/PointDueToReferralModal'

interface IProps {
    className?: string
}

const PointPage: React.FC<IProps> = ({className}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const {goUserDetail} = useNavigation()
    const {data, pageInfo} = useQueryGetPoint(currentPage)
    const {data: pointSummary, refetch} = useQueryGetPointSummary()
    const {displayAmount} = useDisplayNumber()
    const date = useMemo(() => {
        const year = new Date().getUTCFullYear()
        const month = new Date().getUTCMonth() + 1
        const day = new Date().getUTCDay()

        return `${year}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`
    }, [])

    const viewReferralPointModalRef = useRef<any>(null)

    return (
        <PageLayout title={'Point'}>
            <article className={'grid grid-cols-2 gap-[30px] sm:grid-cols-1'}>
                <section>
                    <Text className={'text-h4 text-font01'}>Total Point</Text>
                    <Text className={'text-h1 text-alt_blue'}>{displayAmount(pointSummary?.total_amount)}</Text>
                    <div
                        className={
                            'mt-[20px] shadow-normal bg-white rounded-[10px] p-[20px] grid grid-cols-2 gap-[30px]'
                        }>
                        <Text className={'text-center col-span-2 text-h3'}>Daily Check</Text>
                        <div>
                            <Text className={'text-h4 text-white text-center py-[5px] bg-blue-500 rounded-[5px]'}>
                                Today <Span className={'text-body3 text-white'}>({date} UTC+0)</Span>
                            </Text>
                            <div className={'mt-[20px]'}>
                                <Text className={'text-h1 text-center'}>
                                    {pointSummary?.today_daily_check_count?.total} Users
                                </Text>
                                <Text className={'text-font03 text-center'}>
                                    (KO: {pointSummary?.today_daily_check_count?.ko} / EN:
                                    {pointSummary?.today_daily_check_count?.en})
                                </Text>
                            </div>
                        </div>
                        <div className={''}>
                            <Text className={'text-h4 text-font02 text-center py-[5px] bg-line01 rounded-[5px]'}>
                                Yesterday
                            </Text>
                            <div className={'mt-[20px]'}>
                                <Text className={'text-h1 text-center text-font02'}>
                                    {pointSummary?.yesterday_daily_check_count?.total} Users
                                </Text>
                                <Text className={'text-font03 text-center'}>
                                    (KO: {pointSummary?.yesterday_daily_check_count?.ko} / EN:
                                    {pointSummary?.yesterday_daily_check_count?.en})
                                </Text>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <Text className={'text-h4 text-font01'}>Point due to Referral</Text>
                    <TableHeader className={'grid-cols-[3fr_1fr_1fr_1fr] md:hidden lg:gap-x-[10px] mt-[10px]'}>
                        <Text>Name</Text>
                        <Text>Point</Text>
                        <Text className={''}>Inviters</Text>
                        <Text className={''}></Text>
                    </TableHeader>
                    <TableLayout>
                        {data?.map(item => (
                            <>
                                <TableItem
                                    key={item?.user_name}
                                    className={'grid-cols-[3fr_1fr_1fr_1fr] md:block lg:gap-x-[10px] sm:px-[22px]'}
                                    onClick={() => goUserDetail(item?.user_id)}>
                                    <Text className={'text-ti2'}>{item?.user_name}</Text>
                                    <Text className={'text-ti1 text-alt_blue'}>{item?.points}</Text>
                                    <Text className={'text-font02'}>{item?.inviters?.length}</Text>
                                    <div className={'text-right'}>
                                        <WizButton
                                            text={'View List'}
                                            className={'w-min'}
                                            onClick={e => {
                                                viewReferralPointModalRef?.current?.show(item)
                                                e?.stopPropagation()
                                            }}
                                        />
                                    </div>
                                </TableItem>
                            </>
                        ))}
                    </TableLayout>
                    <WizPagination
                        totalPage={pageInfo?.total_count}
                        currentPage={currentPage}
                        onPageChange={item => setCurrentPage(item)}
                        isScrollTop={false}
                    />
                </section>
            </article>
            <PointDueToReferralModal ref={viewReferralPointModalRef} />
        </PageLayout>
    )
}

export default PointPage
